import { render, staticRenderFns } from "./PrintNotice.vue?vue&type=template&id=5d80ffa1&scoped=true&"
import script from "./PrintNotice.vue?vue&type=script&lang=js&"
export * from "./PrintNotice.vue?vue&type=script&lang=js&"
import style0 from "./PrintNotice.vue?vue&type=style&index=0&id=5d80ffa1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d80ffa1",
  null
  
)

export default component.exports